export async function sendEmail(details, include_sender) {
  try {
    const headers = {
      'x-api-key': process.env.REACT_APP_email_service_api_key,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    await FetchRequest(
      `${process.env.REACT_APP_email_service_url}?include_sender=${include_sender}`,
      'POST',
      headers,
      JSON.stringify(details)
    );
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
}
function timeout(s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(`Operation timed out after ${s} secs.`);
    }, s * 1000);
  });
}
async function FetchRequest(url, method, headers, body) {
  try {
    const response = await Promise.race([fetch(url, { method, headers, body }), timeout(10)]);
    return await response.json();
  } catch (e) {
    throw e;
  }
}
